import type { PropsWithChildren } from 'react'

import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

import { FallBack } from '@components'
import { store, persistor } from '@store'

import { AppInitGate } from './AppInitGate'
import { GoogleAuthGate } from './GoogleAuthGate'
import { SentryProvider } from './SentryProvider'
import { UiGate } from './UiGate'

export function Providers({ children }: PropsWithChildren) {
  return (
    <SentryProvider>
      <Provider store={store}>
        <PersistGate loading={<FallBack />} persistor={persistor}>
          <BrowserRouter>
            <GoogleAuthGate>
              <UiGate>
                <AppInitGate>{children}</AppInitGate>
              </UiGate>
            </GoogleAuthGate>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </SentryProvider>
  )
}
